import { render, staticRenderFns } from "./CreateProductsView.vue?vue&type=template&id=e89972b0&"
import script from "./CreateProductsView.vue?vue&type=script&lang=js&"
export * from "./CreateProductsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports